import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ExpiredTitle, GoToLoginButton, SessionExpiredCont } from './SessionExpired.styles';
import SafeHtml from '../../components/SafeHtml/SafeHtml';
import { RouteNames } from '../../constans/routes';

const SessionExpired: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <SessionExpiredCont id="SessionExpiredCont">
      <ExpiredTitle id="ExpiredTitle">
        <SafeHtml html={t('notFound.expired')} />
        <GoToLoginButton
          data-testid="GoToLoginButtonTest"
          onClick={() => navigate(RouteNames.Login)}
        >
          {t('notFound.login')}
        </GoToLoginButton>
      </ExpiredTitle>
    </SessionExpiredCont>
  );
};

export default SessionExpired;
